import React from 'react';
import axios from "axios";
import Config from "../Config"

export default class Util {
    static renderLoading() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="loader">
                            <span/>
                            <span/>
                            <span/>
                            <span/>
                            <span/>
                            <span/>
                            <span/>
                            <span/>
                            <span/>
                            <span/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    static loadData(url, result) {
        axios.get(url || Config.LOAD_PATIENTS_API, Config.AXIOS_CONFIG).then(result);
    }

    static savePatient(patient, result) {
        axios.post(Config.SAVE_PATIENT_API, patient, Config.AXIOS_CONFIG).then(result);
    }

    static saveConsults(consults, result) {
        axios.post(Config.SAVE_CONSULTS_API, consults, Config.AXIOS_CONFIG).then(result);
    }

    static translateAges(ages) {
        console.log(ages);
        for (let i = 0; i < ages.length; i++) {
            if (ages[i] === "JustBorn")
                ages[i] = "0-6 días";
            if (ages[i] === "NewBorn")
                ages[i] = "7-29 días";
            if (ages[i] === "Infant")
                ages[i] = "1-12 meses";
            if (ages[i] === "OldInfant")
                ages[i] = "1-2 años";
            if (ages[i] === "PreSchool")
                ages[i] = "3-5 años";
            if (ages[i] === "School")
                ages[i] = "6-11 años";
            if (ages[i] === "Pubescent")
                ages[i] = "12-14 años";
            if (ages[i] === "Teenager")
                ages[i] = "15-18 años";
            if (ages[i] === "Adult")
                ages[i] = "+18 años";
        }
        return ages;
    }
}